import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from '@/components/Layout';

import WorkplacesPage from '@/pages/WorkplacesPage';
import EmployeesPage from '@/pages/parametrizacion/employees/EmployeesPage';
import ProductsPage from '@/pages/parametrizacion/products/ProductsPage';
import ServicesPage from '@/pages/parametrizacion/services/ServicesPage';
import ProvidersPage from '@/pages/parametrizacion/providers/ProvidersPage';

import LaundriesPage from '@/pages/parametrizacion/laundries/LaundriesPage';
import ClientsParametrizationPage from '@/pages/parametrizacion/clients/ClientsPage';
import MachinesPage from './pages/parametrizacion/machines/MachinesPage';
import GarmentTypesPage from './pages/parametrizacion/garmentTypes/GarmentTypesPage';
import ClientGarmentsPage from './pages/parametrizacion/clientGarments/ClientGarmentsPage';
import GarmentFamiliesPage from './pages/parametrizacion/garmentFamilies/GarmentFamiliesPage';
import WashingProgramsPage from './pages/parametrizacion/washingPrograms/WashingProgramsPage';
import ClientsPage from '@/pages/ClientsPage';
import TimeClockPage from '@/pages/TimeClockPage';
import HoursTrackingPage from '@/pages/HoursTrackingPage';
import LaundryReceptionPage from '@/pages/LaundryReceptionPage';
import InventoryReturnsPage from '@/pages/InventoryReturnsPage';
import LoginPage from '@/pages/LoginPage';
import UnauthorizedPage from '@/pages/UnauthorizedPage';
import UsuariosPage from '@/pages/parametrizacion/usuarios/UsuariosPage';
import DirtyClothesReceptionPage from '@/pages/reception/DirtyClothesReceptionPage';
import WashingCyclesPage from '@/pages/washingCycles/WashingCyclesPage';
import DryersPage from '@/pages/parametrizacion/dryers/DryersPage';
import DryingCyclesPage from '@/pages/dryingCycles/DryingCyclesPage';
import MonitoringCenterPage from '@/pages/monitoring/MonitoringCenterPage';
import UtilityServicesPage from '@/pages/utilityServices/UtilityServicesPage';
import UtilityServicesGridPage from '@/pages/utilityServices/UtilityServicesGridPage';
import WorkedHoursPage from '@/pages/workedHours/WorkedHoursPage';
import InventoryRegistriesPage from '@/pages/inventoryRegistries/InventoryRegistriesPage';
import ShiftManagementPage from '@/pages/shiftManagement/ShiftManagementPage';
import WeeklyOverviewPage from '@/pages/shiftManagement/WeeklyOverviewPage';
import LaundryDashboard from '@/pages/laundry/LaundryDashboard';
import ReporteSupervisorPage from '@/pages/laundry/ReporteSupervisorPage';
import OperatorDashboard from '@/pages/operator/OperatorDashboard';
import OperatorClockInPage from '@/pages/operator/OperatorClockInPage';
import OperatorRecordsPage from '@/pages/operator/OperatorRecordsPage';
import OperatorShiftsPage from '@/pages/operator/OperatorShiftsPage';
import OperatorDocumentsPage from '@/pages/operator/OperatorDocumentsPage';
import ForgotPasswordPage from '@/pages/ForgotPasswordPage';
import ResetPasswordPage from '@/pages/ResetPasswordPage';
import ChangePasswordPage from '@/pages/profile/ChangePasswordPage';
import { Toaster } from '@/components/ui/toaster';
import { DataProvider } from '@/contexts/DataContext';
import { AuthProvider, useAuth, ProtectedRoute, MODULES } from '@/contexts/AuthContext';
import { NotificationsProvider } from '@/contexts/NotificationsContext';
import ReportsPage from '@/pages/reports/ReportsPage';
import Reportes360Page from '@/pages/reports/v2/Reportes360Page';
import DashboardHomePage from '@/pages/dashboard/DashboardHomePage';
import DashboardPage from '@/pages/dashboard/DashboardPage';
import ComparativoLavanderiasPage from '@/pages/dashboard/ComparativoLavanderiasPage';
import CortesMensualesPage from '@/pages/dashboard/CortesMensualesPage';
import AgentesPage from '@/pages/dashboard/AgentesPage';
import HorasAutorizadasPage from '@/pages/horasAutorizadas/HorasAutorizadasPage';
import BillingPage from '@/pages/billing/BillingPage';
import LiquidacionPage from '@/pages/billing/LiquidacionPage';
import FacturacionPage from '@/pages/billing/FacturacionPage';
import LaundryProductsPage from '@/pages/laundry/LaundryProductsPage';
import EmployeeDocumentsPage from '@/pages/documents/EmployeeDocumentsPage';
import LaundryCenterDocumentsPage from '@/pages/documents/LaundryCenterDocumentsPage';
import DocumentationHomePage from '@/pages/documents/DocumentationHomePage';
import EmployeesDocsHome from '@/pages/documents/EmployeesDocsHome';
import CentersDocsHome from '@/pages/documents/CentersDocsHome';
import DocumentTypesPage from '@/pages/parametrizacion/documentTypes/DocumentTypesPage';
import EmployeeControlPage from '@/pages/EmployeeControl/EmployeeControlPage';
import EmployeePayrollPage from '@/pages/payroll/EmployeePayrollPage';
import InventarioClientesPage from '@/pages/laundry/inventario-clientes/InventarioClientesPage';
import ClienteInventarioDetail from '@/pages/laundry/inventario-clientes/ClienteInventarioDetail';
import RutaClientesPage from '@/pages/laundry/rutas/RutaClientesPage';
import GestionEntregasPage from '@/pages/laundry/rutas/GestionEntregasPage';
import AlistamientosPage from '@/pages/laundry/alistamientos/AlistamientosPage';
import AlistamientosReportesPage from '@/pages/laundry/alistamientos/AlistamientosReportesPage';
import VerificacionRopaSuciaPage from '@/pages/laundry/verificacion-ropa/VerificacionRopaSuciaPage';
import SolicitudesDesarrolloPage from '@/pages/solicitudes-desarrollo/SolicitudesDesarrolloPage';
import ReporteConductoresPage from '@/pages/reportes/ReporteConductoresPage';
import DashboardConductor from '@/pages/conductor/DashboardConductor';
import VehiclesPage from '@/pages/parametrizacion/vehicles/VehiclesPage';
import ClientDashboard from '@/pages/cliente/ClientDashboard';
import ClientRecepcionRopa from '@/pages/cliente/ClientRecepcionRopa';
import ClientePrendasDashboard from '@/pages/cliente-prendas/ClientePrendasDashboard';
import ClientePrendasRecolecciones from '@/pages/cliente-prendas/ClientePrendasRecolecciones';
import ClientePrendasEntregas from '@/pages/cliente-prendas/ClientePrendasEntregas';
import ClientePrendasBalance from '@/pages/cliente-prendas/ClientePrendasBalance';
import ManualPage from '@/pages/manual/ManualPage';
import RecepcionRopaClientesPage from '@/pages/laundry/recepcion-ropa-clientes/RecepcionRopaClientesPage';
import OcupacionClientesPage from '@/pages/laundry/ocupacion-clientes/OcupacionClientesPage';
import AusenciasCentroPage from '@/pages/laundry/ausencias/AusenciasCentroPage';
import RegistroPrendasRFIDPage from '@/pages/registro-prendas-rfid/RegistroPrendasRFIDPage';
import RFIDDashboard from '@/pages/registro-prendas-rfid/RFIDDashboard';
import ConteoPrendasRFIDPage from '@/pages/registro-prendas-rfid/ConteoPrendasRFIDPage';
import FinancieroDashboard from '@/pages/financiera/FinancieroDashboard';
import CentroCostosPage from '@/pages/financiera/centro-costos/CentroCostosPage';
import ReportesFinancierosPage from '@/pages/financiera/reportes/ReportesFinancierosPage';
import LiquidacionClientesPage from '@/pages/financiera/liquidacion-clientes/LiquidacionClientesPage';
import LiquidacionClientePage from '@/pages/financiera/liquidacion-clientes/LiquidacionClientePage';
import ParametrizacionCentrosPage from '@/pages/parametrizacion/centros/ParametrizacionCentrosPage';
import PersonalLayout from '@/pages/personal/PersonalLayout';
import PersonalResumenPage from '@/pages/personal/PersonalResumenPage';
import PersonalEmpleadosPage from '@/pages/personal/PersonalEmpleadosPage';
import PersonalFichaPage from '@/pages/personal/PersonalFichaPage';
import IncapacidadesPage from '@/pages/personal/IncapacidadesPage';
import PermisosPage from '@/pages/personal/PermisosPage';
import ComunicacionesPage from '@/pages/personal/ComunicacionesPage';
import DocumentosPage from '@/pages/personal/documentos/DocumentosPage';
import NominaPagosPage from '@/pages/personal/NominaPagosPage';
import NominaListPage from '@/pages/personal/nomina/NominaListPage';
import NominaDetallePage from '@/pages/personal/nomina/NominaDetallePage';
import PersonalAdministrativoPage from '@/pages/personal/administrativo/PersonalAdministrativoPage';
import NominaDirectaListPage from '@/pages/personal/nomina-directa/NominaDirectaListPage';
import NominaDirectaDetallePage from '@/pages/personal/nomina-directa/NominaDirectaDetallePage';
import ParamFestivosPage from '@/pages/personal/parametrizacion/FestivosPage';
import ParamRecargosPage from '@/pages/personal/parametrizacion/RecargosPage';
import ParamConceptosPage from '@/pages/personal/parametrizacion/ConceptosPage';
import FirmasPage from '@/pages/personal/parametrizacion/FirmasPage';
import ParametrizacionGeneralPage from '@/pages/personal/parametrizacion/GeneralPage';
import CentroParametrizacionPage from '@/pages/parametrizacion/centros/CentroParametrizacionPage';

// Utilidad: detectar si el usuario es operario/operador
const isOperarioUser = (user) => {
  if (!user) return false;
  // roles en array
  if (Array.isArray(user.roles)) {
    const roles = user.roles.map((r) => String(r || '').toLowerCase().trim());
    if (roles.includes('operario') || roles.includes('operador')) return true;
  }
  // rol/role en string
  const primary = String(user.rol ?? user.role ?? '').toLowerCase().trim();
  return primary === 'operario' || primary === 'operador';
};

// Utilidad: detectar si el usuario es cliente
const isClienteUser = (user) => {
  if (!user) return false;
  const primary = String(user.rol ?? user.role ?? '').toLowerCase().trim();
  return primary === 'cliente';
};

// Utilidad: detectar si el usuario es conductor
const isConductorUser = (user) => {
  if (!user) return false;
  const primary = String(user.rol ?? user.role ?? '').toLowerCase().trim();
  return primary === 'conductor';
};

// Utilidad: detectar si el usuario es cliente_prendas
const isClientePrendasUser = (user) => {
  if (!user) return false;
  const primary = String(user.rol ?? user.role ?? '').toLowerCase().trim();
  return primary === 'cliente_prendas';
};

// Utilidad: detectar si el usuario es de servicios públicos.
// Este rol SOLO tiene acceso al módulo UtilityServices, así que su
// landing por defecto debe ser directamente la página de servicios
// públicos del centro al que está asignado.
const isServiciosPublicosUser = (user) => {
  if (!user) return false;
  const primary = String(user.rol ?? user.role ?? '').toLowerCase().trim();
  return primary === 'servicios_publicos';
};

// Devuelve la URL del dashboard del centro asignado al usuario.
// Si el usuario de servicios públicos no tiene lavandería asignada,
// cae al listado general de centros como fallback (el admin debería
// asignarle una lavandería, pero esto evita dejarlo en /unauthorized).
const serviciosPublicosLanding = (user) => {
  const lavId = user?.lavanderia?.id || user?.lavanderia?._id;
  if (lavId) return `/centros-lavado/${lavId}`;
  return '/centros-lavado';
};

// Componente para rutas públicas que redirigen si el usuario ya está autenticado
const PublicRoute = ({ children }) => {
  const { user } = useAuth();
  if (!user) return children;
  if (isOperarioUser(user)) return <Navigate to="/operario-dashboard" replace />;
  if (isClienteUser(user)) return <Navigate to="/cliente-dashboard" replace />;
  if (isConductorUser(user)) return <Navigate to="/conductor" replace />;
  if (isClientePrendasUser(user)) return <Navigate to="/mis-prendas" replace />;
  if (isServiciosPublicosUser(user)) {
    const to = serviciosPublicosLanding(user);
    if (to) return <Navigate to={to} replace />;
  }
  return <Navigate to="/dashboard" replace />;
};

// Landing por defecto según rol
const DefaultLanding = () => {
  const { user } = useAuth();
  if (isOperarioUser(user)) return <Navigate to="/operario-dashboard" replace />;
  if (isClienteUser(user)) return <Navigate to="/cliente-dashboard" replace />;
  if (isConductorUser(user)) return <Navigate to="/conductor" replace />;
  if (isClientePrendasUser(user)) return <Navigate to="/mis-prendas" replace />;
  if (isServiciosPublicosUser(user)) {
    // Solo este rol tiene permiso para acceder; los demás caen al
    // redirect por defecto que termina en /unauthorized.
    const to = serviciosPublicosLanding(user);
    if (to) return <Navigate to={to} replace />;
  }
  return <Navigate to="/dashboard" replace />;
};

function AppContent() {
  return (
    <Layout>
      <Routes>
        {/* Rutas públicas */}
        <Route path="/login" element={
          <PublicRoute>
            <LoginPage />
          </PublicRoute>
        } />
        <Route path="/forgot-password" element={
          <PublicRoute>
            <ForgotPasswordPage />
          </PublicRoute>
        } />
        <Route path="/reset-password" element={
          <PublicRoute>
            <ResetPasswordPage />
          </PublicRoute>
        } />

        {/* Ruta raíz redirige según rol si autenticado, sino a login */}
        <Route path="/" element={
          <ProtectedRoute>
            <DefaultLanding />
          </ProtectedRoute>
        } />

        {/* Rutas protegidas */}
        <Route path="/panel" element={
          <ProtectedRoute requiredModule="reports">
            <DashboardPage />
          </ProtectedRoute>
        } />
        <Route path="/dashboard" element={
          <ProtectedRoute requiredModule="reports">
            <DashboardHomePage />
          </ProtectedRoute>
        } />
        <Route path="/dashboard/eficiencia" element={
          <ProtectedRoute requiredModule="reports">
            <ReportsPage />
          </ProtectedRoute>
        } />
        <Route path="/dashboard/reportes-360" element={
          <ProtectedRoute requiredModule="reports">
            <Reportes360Page />
          </ProtectedRoute>
        } />
        <Route path="/dashboard/reportes-360/lotes-vs-ciclos" element={
          <ProtectedRoute requiredModule="reports">
            <Reportes360Page />
          </ProtectedRoute>
        } />
        <Route path="/dashboard/comparativo" element={
          <ProtectedRoute requiredModule="reports">
            <ComparativoLavanderiasPage />
          </ProtectedRoute>
        } />
        <Route path="/dashboard/cortes" element={
          <ProtectedRoute requiredModule="reports">
            <CortesMensualesPage />
          </ProtectedRoute>
        } />
        <Route path="/dashboard/agentes" element={
          <ProtectedRoute requiredModule="reports">
            <AgentesPage />
          </ProtectedRoute>
        } />
        {/* Facturación dashboard */}
        <Route path="/liquidacion" element={
          <ProtectedRoute requiredModule={MODULES.BILLING_GENERATE}>
            <LiquidacionPage />
          </ProtectedRoute>
        } />
        <Route path="/facturacion" element={
          <ProtectedRoute requiredModule={MODULES.BILLING}>
            <FacturacionPage />
          </ProtectedRoute>
        } />
        {/* Legacy/alias route redirects to Liquidación */}
        <Route path="/billing" element={<Navigate to="/liquidacion" replace />} />

        <Route path="/centros-lavado" element={
          <ProtectedRoute requiredModule="workplaces">
            <WorkplacesPage />
          </ProtectedRoute>
        } />

        <Route path="/parametrizacion/empleados" element={
          <ProtectedRoute requiredModule="employees">
            <EmployeesPage />
          </ProtectedRoute>
        } />

        <Route path="/parametrizacion/productos" element={
          <ProtectedRoute requiredModule="products">
            <ProductsPage />
          </ProtectedRoute>
        } />

        <Route path="/parametrizacion/proveedores" element={
          <ProtectedRoute requiredModule="providers">
            <ProvidersPage />
          </ProtectedRoute>
        } />

        <Route path="/parametrizacion/centros-lavado" element={
          <ProtectedRoute requiredModule="laundries">
            <LaundriesPage />
          </ProtectedRoute>
        } />

        <Route path="/parametrizacion/centros" element={
          <ProtectedRoute requiredModule="laundries">
            <ParametrizacionCentrosPage />
          </ProtectedRoute>
        } />

        <Route path="/parametrizacion/centros/:idLavanderia" element={
          <ProtectedRoute requiredModule="laundries">
            <CentroParametrizacionPage />
          </ProtectedRoute>
        } />

        <Route path="/parametrizacion/clientes" element={
          <ProtectedRoute requiredModule="clients">
            <ClientsParametrizationPage />
          </ProtectedRoute>
        } />

        <Route path="/parametrizacion/lavadoras" element={
          <ProtectedRoute requiredModule="machines">
            <MachinesPage />
          </ProtectedRoute>
        } />

        <Route path="/parametrizacion/secadoras" element={
          <ProtectedRoute requiredModule="machines">
            <DryersPage />
          </ProtectedRoute>
        } />

        <Route path="/parametrizacion/tipos-prenda" element={
          <ProtectedRoute requiredModule="garment_types">
            <GarmentTypesPage />
          </ProtectedRoute>
        } />

        <Route path="/parametrizacion/prendas-clientes" element={
          <ProtectedRoute requiredModule="clients">
            <ClientGarmentsPage />
          </ProtectedRoute>
        } />

        <Route path="/parametrizacion/familia-prendas" element={
          <ProtectedRoute requiredModule="garment_types">
            <GarmentFamiliesPage />
          </ProtectedRoute>
        } />

        <Route path="/parametrizacion/programas-lavado" element={
          <ProtectedRoute requiredModule="washing_programs">
            <WashingProgramsPage />
          </ProtectedRoute>
        } />

        <Route path="/parametrizacion/tipos-archivo" element={
          <ProtectedRoute requiredModule="document_types">
            <DocumentTypesPage />
          </ProtectedRoute>
        } />

        <Route path="/parametrizacion/servicios" element={
          <ProtectedRoute requiredModule="services">
            <ServicesPage />
          </ProtectedRoute>
        } />

        <Route path="/parametrizacion/usuarios" element={
          <ProtectedRoute requiredModule="users">
            <UsuariosPage />
          </ProtectedRoute>
        } />

        <Route path="/parametrizacion/vehiculos" element={
          <ProtectedRoute requiredModule="vehicles">
            <VehiclesPage />
          </ProtectedRoute>
        } />

        <Route path="/clientes" element={
          <ProtectedRoute requiredModule="clients">
            <ClientsPage />
          </ProtectedRoute>
        } />

        <Route path="/fichaje" element={
          <ProtectedRoute>
            <TimeClockPage />
          </ProtectedRoute>
        } />

        <Route path="/horas" element={
          <ProtectedRoute>
            <HoursTrackingPage />
          </ProtectedRoute>
        } />

        {/* Rutas específicas de centros de lavado - DEBEN IR ANTES de la ruta general */}
        <Route path="/centros-lavado/:idLavanderia/alistamientos" element={
          <ProtectedRoute requiredModule="workplaces">
            <AlistamientosPage />
          </ProtectedRoute>
        } />

        <Route path="/centros-lavado/:idLavanderia/reportes-alistamientos" element={
          <ProtectedRoute requiredModule="workplaces">
            <AlistamientosReportesPage />
          </ProtectedRoute>
        } />

        <Route path="/centros-lavado/:idLavanderia/reporte-supervisor" element={
          <ProtectedRoute requiredModule="workplaces">
            <ReporteSupervisorPage />
          </ProtectedRoute>
        } />

        <Route path="/centros-lavado/:idLavanderia/rutas" element={
          <ProtectedRoute requiredModule="workplaces">
            <RutaClientesPage />
          </ProtectedRoute>
        } />

        <Route path="/centros-lavado/:idLavanderia/gestion-entregas" element={
          <ProtectedRoute requiredModule="workplaces">
            <GestionEntregasPage />
          </ProtectedRoute>
        } />

        <Route path="/centros-lavado/:idLavanderia/verificacion-ropa" element={
          <ProtectedRoute requiredModule="workplaces">
            <VerificacionRopaSuciaPage />
          </ProtectedRoute>
        } />

        <Route path="/centros-lavado/:idLavanderia/recepcion-ropa-clientes" element={
          <ProtectedRoute requiredModule="workplaces">
            <RecepcionRopaClientesPage />
          </ProtectedRoute>
        } />

        <Route path="/centros-lavado/:idLavanderia/ocupacion-clientes" element={
          <ProtectedRoute requiredModule="workplaces">
            <OcupacionClientesPage />
          </ProtectedRoute>
        } />

        <Route path="/centros-lavado/:idLavanderia/recepcion" element={
          <ProtectedRoute requiredModule="workplaces">
            <DirtyClothesReceptionPage />
          </ProtectedRoute>
        } />

        <Route path="/centros-lavado/:idLavanderia/ciclos" element={
          <ProtectedRoute requiredModule="workplaces">
            <WashingCyclesPage />
          </ProtectedRoute>
        } />

        <Route path="/centros-lavado/:idLavanderia/ciclos-secado" element={
          <ProtectedRoute requiredModule="workplaces">
            <DryingCyclesPage />
          </ProtectedRoute>
        } />

        <Route path="/centros-lavado/:idLavanderia/servicios" element={
          <ProtectedRoute requiredModule="utility_services">
            <UtilityServicesPage />
          </ProtectedRoute>
        } />

        {/* Vista alterna del mismo modulo: planilla mensual editable */}
        <Route path="/centros-lavado/:idLavanderia/servicios/planilla" element={
          <ProtectedRoute requiredModule="utility_services">
            <UtilityServicesGridPage />
          </ProtectedRoute>
        } />

        <Route path="/centros-lavado/:idLavanderia/productos" element={
          <ProtectedRoute requiredModule="workplaces">
            <LaundryProductsPage />
          </ProtectedRoute>
        } />

        {/* Tareas */}
        <Route path="/solicitudes-desarrollo" element={
          <ProtectedRoute requiredModule="solicitudes">
            <SolicitudesDesarrolloPage />
          </ProtectedRoute>
        } />

        {/* Reportes */}
        <Route path="/reportes" element={<Navigate to="/dashboard/eficiencia" replace />} />
        <Route path="/reportes/conductores" element={
          <ProtectedRoute requiredModule="workplaces">
            <ReporteConductoresPage />
          </ProtectedRoute>
        } />

        {/* Operario */}
        <Route path="/operario-dashboard" element={
          <ProtectedRoute requiredModule="operario">
            <OperatorDashboard />
          </ProtectedRoute>
        } />
        <Route path="/operario/llegada" element={
          <ProtectedRoute requiredModule="operario">
            <OperatorClockInPage />
          </ProtectedRoute>
        } />
        <Route path="/operario/registros" element={
          <ProtectedRoute requiredModule="operario">
            <OperatorRecordsPage />
          </ProtectedRoute>
        } />
        <Route path="/operario/turnos" element={
          <ProtectedRoute requiredModule="operario">
            <OperatorShiftsPage />
          </ProtectedRoute>
        } />
        <Route path="/operario/documentos" element={
          <ProtectedRoute requiredModule="operario">
            <OperatorDocumentsPage />
          </ProtectedRoute>
        } />

        <Route path="/centros-lavado/:idLavanderia/ausencias" element={
          <ProtectedRoute requiredModule="workplaces">
            <AusenciasCentroPage />
          </ProtectedRoute>
        } />

        <Route path="/centros-lavado/:idLavanderia/horas" element={
          <ProtectedRoute requiredModule="workplaces">
            <WorkedHoursPage />
          </ProtectedRoute>
        } />

        <Route path="/centros-lavado/:idLavanderia/inventarios" element={
          <ProtectedRoute requiredModule="workplaces">
            <InventoryRegistriesPage />
          </ProtectedRoute>
        } />

        <Route path="/centros-lavado/:idLavanderia/inventario-clientes" element={
          <ProtectedRoute requiredModule="workplaces">
            <InventarioClientesPage />
          </ProtectedRoute>
        } />

        <Route path="/centros-lavado/:idLavanderia/inventario-clientes/:clienteId" element={
          <ProtectedRoute requiredModule="workplaces">
            <ClienteInventarioDetail />
          </ProtectedRoute>
        } />

        {/* Ruta general del dashboard - DEBE IR AL FINAL de todas las rutas específicas */}
        {/* Accesible por workplaces (roles operativos) o utility_services
            (rol servicios_publicos). El rol servicios_publicos entra al
            dashboard pero solo ve/abre la card de Servicios Públicos; el
            resto de sub-rutas del centro siguen exigiendo workplaces. */}
        <Route path="/centros-lavado/:idLavanderia" element={
          <ProtectedRoute requiredModule={[MODULES.WORKPLACES, MODULES.UTILITY_SERVICES]}>
            <LaundryDashboard />
          </ProtectedRoute>
        } />

        <Route path="/conductor" element={
          <ProtectedRoute requiredModule="conductor">
            <DashboardConductor />
          </ProtectedRoute>
        } />

        <Route path="/rutas" element={
          <ProtectedRoute requiredModule="conductor">
            <RutaClientesPage />
          </ProtectedRoute>
        } />

        {/* Documentos */}
        <Route path="/documentacion" element={
          <ProtectedRoute requiredModule={MODULES.DOCUMENTATION}>
            <DocumentationHomePage />
          </ProtectedRoute>
        } />
        <Route path="/documentacion/empleados" element={
          <ProtectedRoute requiredModule={MODULES.DOCUMENTATION}>
            <EmployeesDocsHome />
          </ProtectedRoute>
        } />
        <Route path="/documentacion/centros" element={
          <ProtectedRoute requiredModule={MODULES.DOCUMENTATION}>
            <CentersDocsHome />
          </ProtectedRoute>
        } />
        <Route path="/documentacion/empleados/:idEmpleado" element={
          <ProtectedRoute requiredModule="employees">
            <EmployeeDocumentsPage />
          </ProtectedRoute>
        } />
        <Route path="/documentacion/centros/:idLavanderia" element={
          <ProtectedRoute requiredModule="workplaces">
            <LaundryCenterDocumentsPage />
          </ProtectedRoute>
        } />
        <Route path="/parametrizacion/empleados/:idEmpleado/documentos" element={
          <ProtectedRoute requiredModule="employees">
            <EmployeeDocumentsPage />
          </ProtectedRoute>
        } />
        <Route path="/centros-lavado/:idLavanderia/documentos" element={
          <ProtectedRoute requiredModule="workplaces">
            <LaundryCenterDocumentsPage />
          </ProtectedRoute>
        } />
        {/* Alias para compatibilidad con tarjetas existentes */}
        <Route path="/centros-lavado/:idLavanderia/documentacion" element={
          <ProtectedRoute requiredModule="workplaces">
            <LaundryCenterDocumentsPage />
          </ProtectedRoute>
        } />

        <Route path="/centros-lavado/:idLavanderia/turnos" element={
          <ProtectedRoute requiredModule="workplaces">
            <ShiftManagementPage />
          </ProtectedRoute>
        } />

        <Route path="/supervision/turnos" element={
          <ProtectedRoute requiredModule="workplaces">
            <WeeklyOverviewPage />
          </ProtectedRoute>
        } />

        <Route path="/control-empleados" element={
          <ProtectedRoute requiredModule="workplaces">
            <EmployeeControlPage />
          </ProtectedRoute>
        } />

        <Route path="/monitor-registros" element={
          <ProtectedRoute requiredModule={MODULES.WORKPLACES}>
            <MonitoringCenterPage />
          </ProtectedRoute>
        } />

        <Route path="/horas-autorizadas" element={
          <ProtectedRoute requiredModule={MODULES.AUTHORIZED_HOURS}>
            <HorasAutorizadasPage />
          </ProtectedRoute>
        } />

        <Route path="/liquidacion-personal" element={
          <ProtectedRoute requiredModule="employee_payroll">
            <EmployeePayrollPage />
          </ProtectedRoute>
        } />

        <Route path="/inventario" element={
          <ProtectedRoute>
            <InventoryReturnsPage />
          </ProtectedRoute>
        } />

        {/* Perfil */}
        <Route path="/perfil/cambiar-contrasena" element={
          <ProtectedRoute>
            <ChangePasswordPage />
          </ProtectedRoute>
        } />


        {/* Portal de Clientes */}
        <Route path="/cliente-dashboard" element={
          <ProtectedRoute requiredModule={MODULES.CLIENT_PORTAL}>
            <ClientDashboard />
          </ProtectedRoute>
        } />
        <Route path="/cliente/recepcion" element={
          <ProtectedRoute requiredModule={MODULES.CLIENT_PORTAL}>
            <ClientRecepcionRopa />
          </ProtectedRoute>
        } />

        {/* Portal Cliente Prendas */}
        <Route path="/mis-prendas" element={
          <ProtectedRoute requiredModule={MODULES.CLIENT_PRENDAS}>
            <ClientePrendasDashboard />
          </ProtectedRoute>
        } />
        <Route path="/mis-prendas/recolecciones" element={
          <ProtectedRoute requiredModule={MODULES.CLIENT_PRENDAS}>
            <ClientePrendasRecolecciones />
          </ProtectedRoute>
        } />
        <Route path="/mis-prendas/entregas" element={
          <ProtectedRoute requiredModule={MODULES.CLIENT_PRENDAS}>
            <ClientePrendasEntregas />
          </ProtectedRoute>
        } />
        <Route path="/mis-prendas/balance" element={
          <ProtectedRoute requiredModule={MODULES.CLIENT_PRENDAS}>
            <ClientePrendasBalance />
          </ProtectedRoute>
        } />

        {/* RFID */}
        <Route path="/rfid" element={
          <ProtectedRoute requiredModule={MODULES.RFID_REGISTRO}>
            <RFIDDashboard />
          </ProtectedRoute>
        } />
        <Route path="/rfid/registro" element={
          <ProtectedRoute requiredModule={MODULES.RFID_REGISTRO}>
            <RegistroPrendasRFIDPage />
          </ProtectedRoute>
        } />
        <Route path="/rfid/conteo" element={
          <ProtectedRoute requiredModule={MODULES.RFID_REGISTRO}>
            <ConteoPrendasRFIDPage />
          </ProtectedRoute>
        } />
        <Route path="/registro-prendas-rfid" element={
          <ProtectedRoute requiredModule={MODULES.RFID_REGISTRO}>
            <RegistroPrendasRFIDPage />
          </ProtectedRoute>
        } />

        {/* Financiera */}
        <Route path="/financiera" element={
          <ProtectedRoute requiredModule={MODULES.FINANCIERA}>
            <FinancieroDashboard />
          </ProtectedRoute>
        } />
        <Route path="/financiera/centro-costos" element={
          <ProtectedRoute requiredModule={MODULES.FINANCIERA}>
            <CentroCostosPage />
          </ProtectedRoute>
        } />
        <Route path="/financiera/liquidacion-clientes" element={
          <ProtectedRoute requiredModule={MODULES.FINANCIERA}>
            <LiquidacionClientesPage />
          </ProtectedRoute>
        } />
        <Route path="/financiera/liquidacion-clientes/:clienteId" element={
          <ProtectedRoute requiredModule={MODULES.FINANCIERA}>
            <LiquidacionClientePage />
          </ProtectedRoute>
        } />
        <Route path="/financiera/reportes" element={
          <ProtectedRoute requiredModule={MODULES.FINANCIERA}>
            <ReportesFinancierosPage />
          </ProtectedRoute>
        } />

        {/* Manual / Instructivo */}
        <Route path="/manual" element={
          <ProtectedRoute>
            <ManualPage />
          </ProtectedRoute>
        } />

        {/* Personal (RR. HH.) - el layout pinta la lateral y cada sección
            tiene su propia URL, así que se puede compartir el enlace directo */}
        <Route path="/personal" element={
          <ProtectedRoute requiredModule={MODULES.PERSONAL}>
            <PersonalLayout />
          </ProtectedRoute>
        }>
          {/* La portada es el listado de personal: registro y descarga */}
          <Route index element={<PersonalEmpleadosPage />} />
          <Route path="resumen" element={<PersonalResumenPage />} />
          {/* /personal/empleados queda como alias del listado */} 
          
          <Route path="empleados" element={<PersonalEmpleadosPage />} />
          <Route path="empleados/:idEmpleado" element={<PersonalFichaPage />} />
          <Route path="incapacidades" element={<IncapacidadesPage />} />
          <Route path="permisos" element={<PermisosPage />} />
          <Route path="comunicaciones" element={<ComunicacionesPage />} />
          <Route path="documentos" element={<DocumentosPage />} />
          <Route path="nomina" element={<NominaListPage />} />
          <Route path="nomina/:id" element={<NominaDetallePage />} />
          <Route path="nomina-pagos" element={<NominaPagosPage />} />
          {/* Personal que no marca en planta y su nómina repartida entre los centros */}
          <Route path="administrativo" element={<PersonalAdministrativoPage />} />
          <Route path="nomina-directa" element={<NominaDirectaListPage />} />
          <Route path="nomina-directa/:id" element={<NominaDirectaDetallePage />} />
          {/* Parametrización propia del módulo */}
          <Route path="parametrizacion" element={<ParametrizacionGeneralPage />} />
          <Route path="parametrizacion/festivos" element={<ParamFestivosPage />} />
          <Route path="parametrizacion/recargos" element={<ParamRecargosPage />} />
          <Route path="parametrizacion/conceptos" element={<ParamConceptosPage />} />
          <Route path="parametrizacion/firmas" element={<FirmasPage />} />
        </Route>

        <Route path="/unauthorized" element={<UnauthorizedPage />} />

        {/* Ruta por defecto para páginas no encontradas */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <DataProvider>
          <NotificationsProvider>
            <AppContent />
            <Toaster />
          </NotificationsProvider>
        </DataProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;